import dateUtil from './dateUtil';

const getFormattedDateTime = (isoDateString: string | Date | undefined, dateTimeFormat: string): string =>
  dateUtil(isoDateString).format(dateTimeFormat);

export default getFormattedDateTime;
